module.exports = __webpack_public_path__ + "media/brands-banner/PhotokiveGrayscaleLogo-37b86862.svg";